import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    TextField,
    Button,
    DialogActions,
    IconButton,
    InputAdornment
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import Cookies from 'js-cookie';
import { UserLogin } from '../service/user_service';
import { AlertError } from './popupAlert';

const LoginModal = ({ open, onClose, onLogin }) => {
    const [showPassword, setShowPassword] = useState(false);

    const [userdata, setUserData] = React.useState({
        username: "",
        password: "",
    });

    const handleChange = (event) => {
        const { name, value } = event.target;
        setUserData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleLogin = async () => {
        if (userdata.password && userdata.username) {
            try {
                // Replace with your actual login API call
                const res = await UserLogin(userdata)
                if (res) {
                    Cookies.set('token', res, { expires: 1 });
                    onLogin();
                    onClose();
                }
                console.log(res);
            } catch (error) {
                console.error('Login error:', error);
                alert('An error occurred during login');
            }
        } else {
            AlertError("ล็อกอินผิดพลาด", "กรุณากรอกข้อมูล");
            return;
        }
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Login to Check-In</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    label="Username"
                    type="text"
                    fullWidth
                    variant="outlined"
                    value={userdata.username}
                    name="username"
                    onChange={handleChange}
                    sx={{ mb: 2 }}
                />
                <TextField
                    margin="dense"
                    label="Password"
                    type={showPassword ? 'text' : 'password'}
                    fullWidth
                    variant="outlined"
                    value={userdata.password}
                    name="password"
                    onChange={handleChange}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    onClick={() => setShowPassword(!showPassword)}
                                    edge="end"
                                >
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                        )
                    }}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="secondary">
                    Cancel
                </Button>
                <Button onClick={handleLogin} color="primary" variant="contained">
                    Login
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default LoginModal;